module.exports = __webpack_public_path__ + "static/media/wave-grc-4.2e9951d6.svg";